import { render, staticRenderFns } from "./NormalSearchNav85.vue?vue&type=template&id=f5e64674&scoped=true"
import script from "./NormalSearchNav85.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav85.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e64674",
  null
  
)

export default component.exports